"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalIdentityProiders = exports.AuthUserSchema = exports.RegisterUserSchema = exports.UserCreateWithFirebase = exports.UserCreateSchema = void 0;
const z = __importStar(require("zod"));
const external_identity_1 = require("./external-identity");
const user_1 = require("../core-model-schemas/user");
const UserIMSchema = user_1.UserSchema.omit({ id: true });
exports.UserCreateSchema = UserIMSchema.extend({
    externalIdentity: external_identity_1.ExternalIdentityIMSchema,
});
exports.UserCreateWithFirebase = UserIMSchema.extend({
    externalIdentity: external_identity_1.ExternalIdentityCreateSchema,
    password: z.string(),
});
exports.RegisterUserSchema = UserIMSchema.omit({ role: true }).extend({
    password: z
        .string()
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{6,}$/, 'Must contain at least one number & uppercase letter & at least 6 characters'),
});
exports.AuthUserSchema = z.object({
    /**
     * The user's `uid`.
     */
    uuid: z.string(),
    /**
     * The user's primary email, if set.
     */
    email: z.string().email(),
    /**
     * The user's display name (may be absent for invite placeholders).
     */
    displayName: z.string().min(1).optional(),
});
var ExternalIdentityProiders;
(function (ExternalIdentityProiders) {
    ExternalIdentityProiders["FIREBASE"] = "FIREBASE";
    // Add more providers here
    // SUSSO = 'susso',
})(ExternalIdentityProiders || (exports.ExternalIdentityProiders = ExternalIdentityProiders = {}));
